import React, { Component } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { RootState } from '../../../store'
import inventoryCaseApi from '../../../apis/inventoryCase.api'
import printService from '../../../services/print.service'
import { replacePage, replaceLimit, replaceSearch } from './StandaloneCases.slice'
import { paginate } from './StandaloneCases.thunk'
import DataTable from '../../../components/DataTable'
import { TableHorizontalHeader } from '../../../components/TableHorizontal'
import { ActionName } from '../../../components/Actions'
import { i18n } from "../../../i18n/i18n";

interface StandaloneCasesProps extends ConnectedProps<typeof connector> {}

class StandaloneCases extends Component<StandaloneCasesProps> {
  headers: TableHorizontalHeader[] = [
    { heading: i18n("Case"), path: 'code' },
    { heading: i18n("Item"), path: 'inventory.inventoriable.item.code' },
    { heading: i18n("Description"), path: 'inventory.inventoriable.item.description' },
    { heading: i18n("Work order"), path: 'inventory.inventoriable.code' },
    { heading: i18n("Created at"),
      path: 'inventory.createdAt',
      date: true,
      tooltip: ['inventory.createdUser.username']
    },
    { heading: i18n("Actions") }
  ]

  constructor (props: StandaloneCasesProps) {
    super(props)
    this.handleLimitChange = this.handleLimitChange.bind(this)
    this.handleSearch = this.handleSearch.bind(this)
    this.handlePaginate = this.handlePaginate.bind(this)
    this.handleActionClick = this.handleActionClick.bind(this)
  }

  handleLimitChange (limit: string) {
    this.props.replaceLimit(Number(limit))
  }

  handleSearch (search: string) {
    this.props.replaceSearch(search)
  }

  handlePaginate (page: number) {
    this.props.replacePage(page)
  }

  printCase (id: number) {
    inventoryCaseApi.print(id, markups => {
      if (!markups) return
      printService.printMarkups(markups)
    })
  }

  handleActionClick (id: number, action: ActionName) {
    if (action === 'print') this.printCase(id)
  }

  componentDidMount () {
    this.props.paginate()
  }

  render () {
    return (
      <DataTable
        headers={this.headers}
        data={this.props.data}
        total={this.props.total}
        from={this.props.from}
        to={this.props.to}
        currentPage={this.props.currentPage}
        lastPage={this.props.lastPage}
        limit={String(this.props.limit)}
        search={this.props.search}
        onLimtChange={this.handleLimitChange}
        onSearch={this.handleSearch}
        onPaginate={this.handlePaginate}
        onActionClick={this.handleActionClick} />
    )
  }
}

const mapStateToProps = (state: RootState) => {
  const { result, limit, search } = state.standaloneCases
  const { data, total, from, to, currentPage, lastPage } = result
  return { data, total, from, to, currentPage, lastPage, limit, search }
}

const mapDispatchToProps = {
  paginate,
  replacePage,
  replaceLimit,
  replaceSearch
}

const connector = connect(mapStateToProps, mapDispatchToProps)
export default connector(StandaloneCases)
